import type { Needs_Bool_Exp } from '@purposity/sdk'

export const LIVE_NEED = {
  _and: [
    { state: { _eq: 'published' } },
    { _not: { checkout_intent: {} } },
    { organization: { private: { _neq: true } } },
  ],
} as const satisfies Needs_Bool_Exp

export const MET_NEED = {
  _or: [
    { state: { _eq: 'purchase_verified' } },
    { state: { _eq: 'purchase_unverified' } },
    { state: { _eq: 'received' } },
  ],
} as const satisfies Needs_Bool_Exp
